<div class="" (window:resize)="isMobile()">
  <app-sidebar
    [ngClass]="{ 'sidenav fixed-left': isMobileResolution === false }"
  >
  </app-sidebar>
  <div class="main-content">
    <app-navbar></app-navbar>
    <div class="" style="min-height: calc( 100vh - 126px );">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>

<!-- <div class="layout row">
    <div class="col-3 top-medicines-container">
      <top-medicines></top-medicines>
    </div>
    <div class="col-9 main-content">
      <app-navbar></app-navbar>
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
</div> -->
